import { render, staticRenderFns } from "./WebShopReceipt.vue?vue&type=template&id=022c245d"
import script from "./WebShopReceipt.vue?vue&type=script&lang=js"
export * from "./WebShopReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports